export default function setQuestionStatus(state, action) {
  const { question, newStatus } = action.payload;
  state.questionList.forEach((q) => {
    if (q._id === question._id) {
      q.disabled = newStatus;
    }
  });
}
